import initSizeGuide from '@sectionsJS/size-guide';

$(async () => {
  initSizeGuide();
});
